import React, { useEffect,useRef,  useState } from 'react';
import TabMenu from '../Fees/Test';
import CustomTable from '../CustomizeTable';
import AppStrings from '../../config/appstring';
import axios from 'axios';


const BonafideList = ({user}) => {
     

     const [items, setItems] = useState([]);
      const [showSlidePanel, setShowSlidePanel] = useState(false);
      const [activeForm, setActiveForm] = useState(null);
      const [selectedReport, setSelectedReport] = useState(null);
      const [ReportQry, setReportQry] = useState(null);
      const [previewImage, setPreviewImage] = useState(null);
  
const imageList = [
  {
    ID: 1,
    PATH: "https://schoolmanagement.agnisofterp.com/bonafide_certificate/3d glass window logo mockup.jpg",
    ACTIVE:"Y"
  },
  {
    ID: 2,
    PATH: "https://schoolmanagement.agnisofterp.com/bonafide_certificate/Picture1.png",
    ACTIVE:"N"
  }
];



 useEffect(() => {
console.log("Logged in as:", user?.name);
  fetchReportList();
}, [user]);


  const fetchReportList = () => {
  axios.get(AppStrings.BonafideImageList)
    .then((response) => {
      console.log(response.data.data, 'list');
      setItems(response.data.data);
    })
    .catch((error) => {
      console.error('Error fetching items:', error);
    });
};

const handleClick = (report) => {
  setShowSlidePanel(false); 
  setActiveForm('Report');
 // setSelectedReport(report); // save the full report object
};

  const handleTabCollectFee =   (reportData) => {
   // console.log(reportData.Datas.Title,'rrrrrrrrrrrr')
   // setSelectedReport({ ID: 0,HEADER:'' });
  setShowSlidePanel(false); 
  setReportQry(reportData.Datas);
  setActiveForm('Report');      
  
   //console.log('Passed to parent:', reportData.Datas);
};

//console.log(selectedReport.ID,'aaaaaaaaaaaa')
  return (
    <>
    {/* <div style={{ fontSize: '20px',
  fontWeight: 'bold',paddingLeft:'20px'}}>Report List</div> */}
   <button style={NameButton}
                        onClick={() => {
    setShowSlidePanel(true);
     fetchReportList();  
  }}
                        >
   Bonafide Certificates
    </button>
    <div className="report-grid">
    <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginTop: '20px' }}>
  {items.map((img) => (
    <div key={img.ID} style={{ width: '200px', cursor: 'pointer' }}>
      <img
        src={img.PATH}
        alt={`Bonafide ${img.ID}`}
        onClick={() => setPreviewImage(img.PATH)}
        style={{
          width: '100%',
          height: 'auto',
          border: `5px solid ${img.ACTIVE === 'Y' ? '#93ff91' : 'transparent'}`,
          borderRadius: '8px',
          opacity: img.ACTIVE === 'Y' ? 1 : 0.7,
          transition: 'all 0.3s ease'
        }}
      />
    </div>
  ))}
</div>

{showSlidePanel  && (
  <div style={{ ...slidePanelStyle, ...slidePanelVisible }}>

     <button 
            style={closeButtonStyle}
            onClick={() => setShowSlidePanel(false)}
            aria-label="Close Slide Panel"
          >
            ✖
          </button>


 
    
  </div>
)}


{previewImage && (
  <div style={modalOverlayStyle}>
    <div style={modalContentStyle}>

      {/* First Row: Close Button */}
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <button 
          style={{ ...closeButtonStyle }} 
          onClick={() => setPreviewImage(null)} 
          aria-label="Close Image Preview"
        >
          ✖
        </button>
      </div>

      {/* Second Row: Image Preview */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
        <div style={{
          width: '60vw',
          height: 'calc(60vw * 1.414)', // A4 ratio
          maxHeight: '70vh',
          backgroundColor: '#f9f9f9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
        }}>
          <img 
            src={previewImage} 
            alt="Preview" 
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
          />
        </div>
      </div>

      {/* Third Row: Action Button */}
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button 
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
          onClick={() => alert("Your action here")}
        >
          Download / Print / Close
        </button>
      </div>

    </div>
  </div>
)}





    </div>
      </>
  );
};

export default BonafideList;

const NameButton = {
  width: '100%',
  height: 'auto',
  backgroundColor: 'transparent',
  color: 'black',
  textAlign: 'left',
  border: 'none',
  padding: '0',
  margin: '0',
  fontWeight: 'bold',
  cursor: 'pointer',
  fontSize:'25px'
}

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 999,
};


const modalContentStyle = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1000,
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
  width: '50vw',      
  height: '90vh',    
  overflowY: 'auto',   
  overflowX: 'auto', 
};



const closeButtonStyle = {
  marginBottom: 10,
  padding: '6px 0px',
  background: '#fff',
  border: 'none',
  borderRadius: 4,
  cursor: 'pointer',
  color:'black',
  width:'20px'
};
const slidePanelVisible = {
  transform: 'translateX(0%)',  // visible on screen
};
const slidePanelStyle = {
  position: 'fixed',
  top: 0,
  right: 0,
  width: '25%',
  height: '100%',
  backgroundColor: '#fff',
  zIndex: 1000,
  padding: '20px',
  transform: 'translateX(100%)',  // hidden initially off screen right
  transition: 'transform 0.3s ease-in-out',
  borderTopLeftRadius: '20px',
  borderBottomLeftRadius: '20px',
  boxShadow: '-2px 0 8px rgba(0, 0, 0, 0.3)',
};

